module.exports = __webpack_public_path__ + "img/1253151066.2c13525f.jpg";